import useRipple from "use-ripple-hook";
import {Tooltip} from "@mui/material";

function ItemNavBar(props: Props) {
  const [ripple, event] = useRipple();

  return (
    <div className={`item ${props.is_active ? 'active' : ''}`} ref={ripple} onMouseDown={event}>
      <div className={props.is_active ? 'number-active' : 'number'}>{props.id}</div>
      <div className={'info'}>
        <Tooltip title={props.name} placement={'top'}>
          <div className={'name'}>{props.name}</div>
        </Tooltip>
        <div className={'time'}>Last updated: {props.last_updated}</div>
      </div>
    </div>
  )
}

export default ItemNavBar;

class Props {
  id?: number;

  name: string;

  last_updated?: string;

  is_active?: boolean;
}